const trimEnv = (value = "") => String(value || "").trim();

export const SITE_NAME =
  trimEnv(process.env.REACT_APP_SITE_NAME || process.env.REACT_APP_APP_NAME) ||
  "Academy Costumes London";

export const SITE_URL =
  trimEnv(process.env.REACT_APP_SITE_URL) || "https://www.academycostumes.co.uk";

export const SITE_DOMAIN = SITE_URL.replace(/^https?:\/\//i, "").replace(
  /\/+$/,
  "",
);

export const SHOP_DEPARTMENTS = ["Haberdashery", "Textiles", "Ready-Made"];
export const SHOP_DEPARTMENTS_TEXT = SHOP_DEPARTMENTS.join(", ");

export const DEFAULT_META_TITLE =
  "Academy Costumes London | Film, TV & Theatre Costume Specialists";
export const DEFAULT_META_DESCRIPTION =
  `${SITE_NAME} provides costume production, bespoke tailoring, vintage textiles, haberdashery and specialist costume services for film, television, theatre, fashion, music and commercials in London.`;
export const DEFAULT_META_KEYWORDS = [
  SITE_NAME,
  "costume supplies",
  "costume fabrics",
  "haberdashery",
  "textiles",
  "ready-made costumes",
  "replica garments",
  "vintage trims",
  "sewing supplies",
  "premium fabrics",
  "silk",
  "cotton",
  "linen",
  "London costume shop",
].join(", ");

export const DEFAULT_META_IMAGE = `${SITE_URL}/icon-512x512.png`;
